<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Empresas'"
      :newRowmodalButtonText="'Nova empresa'"
      :tableHeader="headers"
      :tableRows="empresas"
      :isEdit="true"
      :isFinish="false"
      :isDel="true"
      :isPrint="false"
      :isEndereco="true"
      :totalItens="total"
      v-on:datatable-newrow="onDataTableInsertRow"
      v-on:datatable-updaterow="onDataTableUpdateRow"
      v-on:datatable-deleterow="onDataTableDeleteRow"
      v-on:datatable-endereco="onDataTableEnderecoRow"
      v-on:datatable-update-page="updatePage"
      v-on:datatable-update-search="updateSearch"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>

    <FormModal
      :isTheModalOpen="formModalData.isOpenEnderecos"
      :modalButtonText="formModalData.buttonText"
      :modalFormTitle="formModalData.formTitle"
      :modalType="formModalData.modalType"
      :isLoadingRequestDisable="formModalData.isLoadingRequestDisable"
      :isModalButtonVisible="formModalData.isButtonsVisible"
      :isModalButtonDisabled="formModalData.isButtonsDisabled"
      v-on:formmodal-close="formModalData.isOpenEnderecos = false"
      v-on:formmodal-action="salvarEnderecos"
    >
      <v-row>
        <v-col :cols="12">
          <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>

          <v-data-table :headers="headersEndereco" :items="enderecos">
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Endereços Cadastrados</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="adicionarEndereco">Cadastrar Endereço</v-btn>
              </v-toolbar>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    @click="deleteEndereco(item)"
                    v-bind="attrs"
                    v-on="on"
                    >mdi-delete</v-icon
                  >
                </template>
                <span>Excluir</span>
              </v-tooltip>
            </template>

            <template v-slot:[`item.endereco`]="props">
              <v-edit-dialog
                :return-value.sync="props.item.endereco"
                @save="editarEndereco(props.item)"
                @cancel="cancel"
                @open="open"
                @close="close"
              >
                <div v-if="props.item.endereco">
                  {{ props.item.endereco }}
                </div>

                <div v-if="!props.item.endereco">
                  {{ (props.item.endereco = "") }}
                  Endereço
                </div>

                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.endereco"
                    :rules="[max25chars]"
                    label="Edit"
                    autocomplete="off"
                    single-line
                    counter
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            <template v-slot:[`item.bairro`]="props">
              <v-edit-dialog
                :return-value.sync="props.item.bairro"
                @save="editarEndereco(props.item)"
                @cancel="cancel"
                @open="open"
                @close="close"
              >
                <div v-if="props.item.bairro">
                  {{ props.item.bairro }}
                </div>

                <div v-if="!props.item.bairro">
                  {{ (props.item.bairro = "") }}
                  Bairro do endereço
                </div>

                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.bairro"
                    :rules="[max25chars]"
                    label="Edit"
                    autocomplete="off"
                    single-line
                    counter
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            <template v-slot:[`item.telefone`]="props">
              <v-edit-dialog
                :return-value.sync="props.item.telefone"
                @save="editarEndereco(props.item)"
                @cancel="cancel"
                @open="open"
                @close="close"
              >
                <div v-if="props.item.telefone">
                  {{ props.item.telefone }}
                </div>

                <div v-if="!props.item.telefone">
                  {{ (props.item.telefone = "") }}
                  Telefone do endereço
                </div>

                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.telefone"
                    :rules="[max25chars]"
                    v-mask="['(##) #####-####']"
                    label="Edit"
                    autocomplete="off"
                    single-line
                    counter
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            <template v-slot:[`item.cep`]="props">
              <v-edit-dialog
                :return-value.sync="props.item.cep"
                @save="editarEndereco(props.item)"
                @cancel="cancel"
                @open="open"
                @close="close"
              >
                <div v-if="props.item.cep">
                  {{ props.item.cep }}
                </div>

                <div v-if="!props.item.cep">
                  {{ (props.item.cep = "") }}
                  Cep do endereço
                </div>

                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.cep"
                    :rules="[max25chars]"
                    v-mask="['#####-###']"
                    label="Edit"
                    autocomplete="off"
                    single-line
                    counter
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            <template v-slot:[`item.cevs`]="props">
              <v-edit-dialog
                :return-value.sync="props.item.cevs"
                @save="editarEndereco(props.item)"
                @cancel="cancel"
                @open="open"
                @close="close"
              >
                <div v-if="props.item.cevs">
                  {{ props.item.cevs }}
                </div>

                <div v-if="!props.item.cevs">
                  {{ (props.item.cevs = "") }}
                  Cevs do endereço
                </div>

                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.cevs"
                    :rules="[max25chars]"
                    label="Edit"
                    autocomplete="off"
                    single-line
                    counter
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>

            <template v-slot:[`item.nomeResponsavel`]="props">
              <v-edit-dialog
                :return-value.sync="props.item.nomeResponsavel"
                @save="editarEndereco(props.item)"
                @cancel="cancel"
                @open="open"
                @close="close"
              >
                <div v-if="props.item.nomeResponsavel">
                  {{ props.item.nomeResponsavel }}
                </div>

                <div v-if="!props.item.nomeResponsavel">
                  {{ (props.item.nomeResponsavel = "") }}
                  Nome do responsável
                </div>

                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.nomeResponsavel"
                    :rules="[max25chars]"
                    label="Edit"
                    autocomplete="off"
                    single-line
                    counter
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>

            <template v-slot:[`item.cargoResponsavel`]="props">
              <v-edit-dialog
                :return-value.sync="props.item.cargoResponsavel"
                @save="editarEndereco(props.item)"
                @cancel="cancel"
                @open="open"
                @close="close"
              >
                <div v-if="props.item.cargoResponsavel">
                  {{ props.item.cargoResponsavel }}
                </div>

                <div v-if="!props.item.cargoResponsavel">
                  {{ (props.item.cargoResponsavel = "") }}
                  Cargo do responsável
                </div>

                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.cargoResponsavel"
                    :rules="[max25chars]"
                    label="Edit"
                    autocomplete="off"
                    single-line
                    counter
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
          </v-data-table>

          <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
            {{ snackText }}

            <template v-slot:action="{ attrs }">
              <v-btn v-bind="attrs" text @click="snack = false">
                Close
              </v-btn>
            </template>
          </v-snackbar>
        </v-col>
      </v-row>
    </FormModal>

    <FormModal
      :isTheModalOpen="formModalData.isOpen"
      :modalButtonText="formModalData.buttonText"
      :modalFormTitle="formModalData.formTitle"
      :modalType="formModalData.modalType"
      :isLoadingRequestDisable="formModalData.isLoadingRequestDisable"
      :isModalButtonVisible="formModalData.isButtonsVisible"
      :isModalButtonDisabled="formModalData.isButtonsDisabled"
      v-on:formmodal-close="formModalData.isOpen = false"
      v-on:formmodal-action="onFormModalAction"
    >
      <v-form v-model="estaValido">
        <v-row>
          <v-col cols="12">
            <AlertasModal :tipo="alertaModal.tipo" :texto="alertaModal.texto"></AlertasModal>
          </v-col>
        </v-row>
        
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="formModalData.actualEdit.razaoSocial"
              name="razaoSocial"
              label="Razão Social"
              :rules="[rules.requerido]"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="formModalData.actualEdit.nomeFantasia"
              name="nomeFantasia"
              label="Nome Fantasia"
              :rules="[rules.requerido]"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="textFieldCnpj"
              name="cnpj"
              label="CNPJ"
              v-mask="['##.###.###/####-##']"
              :rules="[rules.cnpjRules]"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="formModalData.actualEdit.telefone"
              name="telefone"
              label="Telefone"
              v-mask="['(##)####-####', '(##)#####-####']"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="formModalData.actualEdit.email"
              name="email"
              label="E-mail"
              autocomplete="off"
              :rules="[rules.emailRules]"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              :items="cnaes"
              label="Selecionar CNAE"
              v-model="cnaeSelecionado"
              append-outer-icon="mdi-plus-thick"
              autocomplete="off"
              @click:append-outer="moreCnae()"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-data-table
              :headers="formModalData.actualEdit.cnaesHeaders"
              :items="formModalData.actualEdit.cnaesVinculados"
              :search="searchCnae"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Cnaes Vinculados</v-toolbar-title>
                </v-toolbar>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <v-icon small @click="removeCnaelist(item)">
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-form>
    </FormModal>
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import axiosNativo from "axios";
import DataTable from "@/components/DataTable2.vue";
import FormModal from "@/components/FormModal.vue";
import store from "@/store/index";
import SkeletonTable from "../components/SkeletonTable";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";

export default {
  components: {
    DataTable,
    FormModal,
    SkeletonTable,
    Alertas,
    AlertasModal,
  },

  data: () => ({
    //Paginação 
    page: 1,
    search: null,
    total: null,
    //Fim da paginação

    rules: {
      requerido: (value) => value != null || "Requer o campo!",
      cnpjRules: v => (v && v.length >= 18) || 'CNPJ Inválido',
      emailRules: v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail Inválido.',
    },

    alerta: {
      texto: "",
      tipo: ""
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    snack: false,
    snackColor: "",
    snackText: "",
    max25chars: (v) => v.length <= 25 || "Input too long!",
    pagination: {},

    latitude: null,
    longitude: null,

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    cnaeSelecionado: null,
    searchCnae: null,

    showSkeletonTable: true,
    validateEmail: null,
    estaValido: false,

    // Cabeçalho da DataTable
    headers: [
      {
        text: "ID",
        value: "numeroEmpresa",
      },
      {
        text: "Razão Social",
        value: "razaoSocial",
      },
      {
        text: "Nome Fantasia",
        value: "nomeFantasia",
      },
      {
        text: "CNPJ",
        value: "cnpj",
      },
      {
        text: "Telefone",
        value: "telefone",
      },
      {
        text: "E-mail",
        value: "email",
      },
      { text: "Atualizar/Excluir", value: "actions", sortable: false },
    ],

    formModalData: {
      isOpen: false,
      isOpenEnderecos: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      isLoadingRequestDisable: false,
      actualEdit: {
        numeroEmpresa: null,
        razaoSocial: null,
        nomeFantasia: null,
        cnpj: null,
        telefone: null,
        email: null,
        cnaesHeaders: [
          {
            text: "ID",
            value: "cnae.numeroCnae",
          },
          {
            text: "Nome",
            value: "cnae.nomeCnae",
          },
          {
            text: "Descrição Cnae",
            value: "cnae.descricaoCnae",
          },
          {
            text: "Código Cnae",
            value: "cnae.codigoCnae",
          },
          { text: "Visualizar", value: "actions", sortable: false },
        ],
        cnaesVinculados: [],
      },
    },

    headersEndereco: [
      {
        text: "Endereço",
        value: "endereco"
      },
      {
        text: "Bairro",
        value: "bairro",
      },
      {
        text: "Telefone",
        value: "telefone",
      },
      {
        text: "Cep",
        value: "cep",
      },
      {
        text: "Cevs",
        value: "cevs",
      },
      {
        text: "Nome Responsável",
        value: "nomeResponsavel",
      },
      {
        text: "Cargo Responsável",
        value: "cargoResponsavel",
      },
      { text: "Excluir", value: "actions", sortable: false },
    ],

    textFieldCnpj: null,
    numeroEmpresaSelecionada: null,
    listaNomeDeEnderecos: [],

    //Array populado pela função initialize
    empresas: [],
    enderecos: [],
    cnaes: [],
  }),

  created() {
    this.initialize();
  },

  watch: {
    estaValido() {
      this.formModalData.isButtonsDisabled = !this.estaValido
    },

    async textFieldCnpj() {
      this.formModalData.actualEdit.cnpj = this.textFieldCnpj //popula valor do watch para actualEdit
      
      const cnpj = {cnpj: this.textFieldCnpj}
      let response = await axios.put("/validaCnpj", cnpj, this.config);

      if(response.data == false) {
        this.alertaModal.texto = "CNPJ já cadastrado no nosso banco de dados";
        this.alertaModal.tipo = "erro"
        this.estaValido = false
      } else {
        this.alertaModal.texto = null;
        this.alertaModal.tipo = null;
      }
    }
  },

  methods: {
    /****************************************************************
     *                 FUNÇÕES DE EVENTO
     **************************************************************** */

    async editarEndereco(item) {
      this.alertaModal.tipo = null;
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Salvo com sucesso";
      await axios.put("editarEndereco", item, this.config);
      this.$socket.emit("insertLog");
    },

    async adicionarEndereco() {
      try {
        this.alertaModal.tipo = null;
        await axios.post("endereco", { numeroEmpresa: this.numeroEmpresaSelecionada }, this.config );
        this.$socket.emit("insertLog");
        await this.buscarEndereco({ numeroEmpresa: this.numeroEmpresaSelecionada, });
      } catch (error) {
        console.log(error);
      }
    },

    cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Canceled";
    },

    open() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Editar";
    },

    close() {
      console.log("Dialog closed");
    },

    async onDataTableUpdateRow(item) {
      this.alertaModal.texto = null
      this.alertaModal.tipo = null;

      this.formModalData.isOpen = true;
      this.formModalData.isEdit = true;
      this.formModalData.isButtonsDisabled = !this.estaValido
      this.formModalData.buttonText = "Atualizar";
      this.formModalData.formTitle = "Atualizar Empresa";

      this.formModalData.actualEdit.numeroEmpresa = item.numeroEmpresa;
      this.formModalData.actualEdit.razaoSocial = item.razaoSocial;
      this.formModalData.actualEdit.nomeFantasia = item.nomeFantasia;
      this.formModalData.actualEdit.cnpj = item.cnpj;
      this.formModalData.actualEdit.email = item.email;
      this.formModalData.actualEdit.telefone = item.telefone;
      let listCnaes = await axios.post("cnaePorEmpresa", { numeroEmpresa: item.numeroEmpresa }, this.config );
      this.formModalData.actualEdit.cnaesVinculados = listCnaes.data;
    },

    onDataTableInsertRow() {
      this.alertaModal.texto = null
      this.alertaModal.tipo = null;

      this.formModalData.isOpen = true;
      this.formModalData.isEdit = false;
      this.formModalData.isButtonsDisabled = !this.estaValido
      this.formModalData.buttonText = "Registrar";
      this.formModalData.formTitle = "Nova Empresa";

      this.formModalData.actualEdit.numeroEmpresa = null;
      this.formModalData.actualEdit.razaoSocial = null;
      this.formModalData.actualEdit.nomeFantasia = null;
      this.formModalData.actualEdit.cnpj = null;
      this.formModalData.actualEdit.email = null;
      this.formModalData.actualEdit.telefone = null;
      this.formModalData.actualEdit.cnaesVinculados = []
      this.cnaeSelecionado = null
    },

    async onDataTableDeleteRow(item) {
      try {
        await this.deleteItem(item);
      } catch (error) {
        console.log(error);
      } finally {
        await this._recoverEmpresa();
      }
    },

    async buscarEndereco(item) {
      try {
        const responseEnderecos = await axios.put("endereco", item, this.config);
        this.enderecos = responseEnderecos.data;
      } catch (error) {
        console.log(error);
      }
    },

    async onDataTableEnderecoRow(item) {
      this.numeroEmpresaSelecionada = item.numeroEmpresa;

      await this.buscarEndereco(item);

      this.formModalData.isOpenEnderecos = true;
      this.formModalData.isEdit = true;
      this.formModalData.buttonText = "Salvar";
      this.formModalData.formTitle = "Endereços";
    },

    async onFormModalAction() {
      try {
        this.formModalData.isButtonsDisabled = true;
        if (this.formModalData.isEdit) {
          await this.update(this.formModalData.actualEdit);
        } else {
          await this.insert(this.formModalData.actualEdit);
        }
      } catch (error) {
        this.mensagemErro = error.response.data.message;
      } finally {
        await this._recoverEmpresa();
        this.formModalData.isButtonsDisabled = false;
        this.formModalData.isOpen = false;
      }
    },

    async salvarEnderecos() {
      this.formModalData.isOpenEnderecos = false;

      let enderecosCoordernadas = await axios.put("verificarCoordenadas", { listaEnderecos: this.enderecos }, this.config );

      //ATUALIZA ENDEREÇO / ADD COORDENADAS
      await Promise.all(enderecosCoordernadas.data.map(async function(enderecoSelecionado) {
      
        if(enderecoSelecionado.buscarCoordernadas == true) {
          try {
            const _axiosMap = axiosNativo.create({
              baseURL: "https://maps.googleapis.com/maps/api/geocode/",

              headers: { 
                'Content-Type': 'application/json'
              }
            })
            const responseEnderecos = await _axiosMap.get("json?address=" + enderecoSelecionado.endereco + ", " + enderecoSelecionado.numero  + " - " + enderecoSelecionado.bairro + ", ITU - SP, " + enderecoSelecionado.cep + "&key=AIzaSyDExmL2iRTiv03n0bfEY1tskc1OFV5Zl4c")

            enderecoSelecionado.latitude = responseEnderecos.data.results[0].geometry.location.lat
            enderecoSelecionado.longitude = responseEnderecos.data.results[0].geometry.location.lng
          } catch (error) {
            console.log(error)
          }
        }

      }))

      await axios.put("editarListaDeEnderecos", enderecosCoordernadas.data, this.config);
      this.$socket.emit("insertLog");
    },

    async deleteEndereco(item) {
      try {
        if(confirm("Você realmente deseja excluir este Endereço?")){
          await axios.delete("endereco", {
            data: item,
            headers: this.config.headers,
          });
          this.buscarEndereco({ numeroEmpresa: this.numeroEmpresaSelecionada });
          this.$socket.emit("insertLog");
          this.snack = true;
          this.snackColor = "success";
          this.snackText = "Endereço removido";
        }
      } catch (error) {
        console.log(error)        
      }
    },

    /****************************************************************
     *                 FUNÇÕES DO COMPONENTE
     **************************************************************** */

    removeCnaelist(item) {
      this.formModalData.actualEdit.cnaesVinculados = this.formModalData.actualEdit.cnaesVinculados.filter(
        (cnae) => cnae.cnae.numeroCnae != item.cnae.numeroCnae
      );
    },

    moreCnae() {
      if(this.cnaeSelecionado) {
        const filtroCnae = this.formModalData.actualEdit.cnaesVinculados.filter(
          (cnae) => cnae.cnae.numeroCnae == this.cnaeSelecionado.cnae.numeroCnae
        )

      
        if(filtroCnae.length <= 0){
          this.formModalData.actualEdit.cnaesVinculados.push(this.cnaeSelecionado); 
        } else {
          this.alertaModal.texto = 'O CNAE já foi adicionado na lista!'
          this.alertaModal.tipo = 'erro'
        }

        this.cnaeSelecionado = null
      }
    },

    fecharNotificacao() {
      this.newNotify.isNewNotify = false;
    },

    async _recoverEmpresa() {
      try {
        const responseEmpresas = await axios.put("listarempresas", {page: this.page, search: this.search}, this.config);
        if(!responseEmpresas.data || responseEmpresas.data.length > 0) {
          this.empresas = responseEmpresas.data;
          this.total = responseEmpresas.data[0].total
        }
        this.showSkeletonTable = false;
        
      } catch (error) {
        console.log(error.response);
      }
    },

    async updateSearch(search) {
      if(search){
        this.search = search
        this.page = 1
        await this._recoverEmpresa()
      } else {
        this.page = 1
      }
    },

    async updatePage(pagination) {
      this.page = pagination.page
      await this._recoverEmpresa()
    },

    async _recoverCnaes() {
      try {
        const responseCnaes = await axios.get("cnae", this.config);
        this.cnaes = responseCnaes.data.map(function(cnaeSelecionado) {
          return {
            text: cnaeSelecionado.codigoCnae,
            value: { cnae: cnaeSelecionado },
          };
        });
      } catch (error) {
        console.log(error.response);
      }
    },

    async initialize() {
      try {
        await this._recoverCnaes();
        await this._recoverEmpresa();
      } catch (error) {
        console.log(error.response);
      }
    },

    async insert(reciveItem) {
      try {
        this.alertaModal.tipo = null;
        await axios.post("empresa", reciveItem, this.config);
        this.$socket.emit("insertLog");

        this.alerta.texto = "Empresa adicionada com sucesso!"
        this.alerta.tipo = 'sucesso';
      } catch (error) {
        console.log(error)
      }
    },

    async update(reciveItem) {
      try {
        this.alertaModal.tipo = null;
        await axios.put("empresa", reciveItem, this.config);
        this.$socket.emit("insertLog");

        this.alerta.texto = "Empresa atualizada com sucesso!"
        this.alerta.tipo = 'sucesso';
      } catch (error) {
        console.log(error)
      }
    },

    async deleteItem(reciveItem) {
      try {
        if(confirm("Você realmente deseja excluir esta Empresa?")) {
          await axios.delete("empresa", {
            data: reciveItem,
            headers: this.config.headers,
          });
          this.$socket.emit("insertLog");
          
          this.alerta.texto = "Empresa removida"
          this.alerta.tipo = 'sucesso';
        }
      } catch (error) {
        console.log(error)        
      }
    },
  },
};
</script>
